<template>
  <GmapMap
    ref="map"
    :center="center"
    :zoom="this.zoomLevel"
    :options="options"
    @dragend="updateCenter">
    <map-marker />
  </GmapMap>
</template>

<script>
import { mapGetters } from 'vuex'
import { gmapApi } from 'vue2-google-maps'
import MapMarker from './MapMarker'

export default {
  components: {
    MapMarker
  },
  props:{
    zoomLevel: {
      type: Number,
      required:false,
      default:15
    }
  },
  mounted () {
    this.$refs.map.$mapPromise.then((map) => {
      this.$store.dispatch('googleMap/updateMap', { map: map, api: this.google})
    })
  },
  data () {
    return {
      options: {
        gestureHandling: 'greedy',
        fullscreenControl: false,
        mapTypeControl: false,
        scaleControl: true,
        zoomControl: false,
        streetViewControl: false,
        clickableIcons: false,
        zoom: this.zoomLevel,
        styles: [{
          featureType: 'poi.business',
          stylers: [
            { visibility: 'off' }
          ]
        }]
      }
    }
  },
  methods: {
    updateCenter: function () {
      this.$refs.map.$mapPromise
        .then((map) => {
          const params = {
            lat: map.center.lat(),
            lng: map.center.lng()
          }
          this.$store.dispatch('map/updateCenter', params)
        })
    }
  },
  computed: {
    ...mapGetters({
      center: 'map/getCenter',
      zoom: 'map/getZoom'
    }),
    google: gmapApi
  }
}
</script>
